import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { NewbuildingPurchaseGiftSidebarTongue } from 'shared/components/NewbuildingPurchaseGiftSidebarTongue';
import { NEWBUILDING_PURCHASE_GIFT_ENTRY_POINT_TEXT } from 'shared/constants/newbuildingPurchaseGiftPromo';

import { useNewbuildingPurchaseGiftPromo } from './NewbuildingPurchaseGiftPromoContext';
import { trackEntryPointShow } from './tracking';

export const NewbuildingPurchaseGiftSidebarTongueContainer: React.FC = () => {
  const { isAvailable, openModal } = useNewbuildingPurchaseGiftPromo();

  const handleShow = React.useCallback(() => trackEntryPointShow('sidebar'), []);
  const handleClick = React.useCallback(() => openModal('sidebar'), [openModal]);

  if (!isAvailable) {
    return null;
  }

  return (
    <ActionAfterViewObserver callback={handleShow} triggerOnce wrapper={false}>
      <NewbuildingPurchaseGiftSidebarTongue text={NEWBUILDING_PURCHASE_GIFT_ENTRY_POINT_TEXT} onClick={handleClick} />
    </ActionAfterViewObserver>
  );
};
